import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
      </Routes>
    </Router>;
}